import { useState, useRef, useEffect } from 'react';
import VideoPlayer from './components/VideoPlayer';
import EPGList from './components/EPGList';
import { FiChevronRight } from 'react-icons/fi';
import { ToastContainer } from 'react-toastify';
import { ErrorBoundary } from 'react-error-boundary';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const [currentStream] = useState(
    process.env.REACT_APP_STREAM_URL || 'https://178.143.53.69:443/hls/stream.m3u8'
  );
  const [showEPG, setShowEPG] = useState(false);
  const epgListRef = useRef(null);

  console.log('Current Stream URL:', currentStream);

  useEffect(() => {
    if (showEPG) {
      epgListRef.current?.scrollToCurrent();
    }
  }, [showEPG]);

  return (
    <ErrorBoundary
      fallbackRender={({ error }) => (
        <div className="alert alert-danger">
          <h4>Application Error</h4>
          <pre>{error.message}</pre>
        </div>
      )}
    >
      <div className="vh-100 vw-100 overflow-hidden position-relative">
        <div className="h-100 w-100">
          <VideoPlayer source={currentStream} />
        </div>

        <button 
          aria-label={showEPG ? "Hide program guide" : "Show program guide"}
          className="btn btn-dark position-fixed rounded-end-pill p-2 border-0 toggle"
          style={{
            top: '50%',
            left: showEPG ? '25%' : 0,
            zIndex: 1000,
            transition: 'left 0.3s ease',
            transform: 'translateY(-50%)'
          }}
          onClick={() => setShowEPG(prev => !prev)}
        >
          <div style={{ transition: 'transform 0.3s ease', transform: showEPG ? 'rotate(180deg)' : 'rotate(0deg)' }}>
            <FiChevronRight size={25} />
          </div>
        </button>

        <div className={`position-fixed vh-100 bg-dark shadow-lg`}
          style={{
            top: 0,
            left: 0,
            transform: showEPG ? 'translateX(0)' : 'translateX(-100%)',
            width: '25%',
            zIndex: 999,
            transition: 'transform 0.3s ease'
          }}
        >
          <EPGList ref={epgListRef} />
        </div>
        <ToastContainer />
      </div>
    </ErrorBoundary>
  );
}

export default App;